// extracted by mini-css-extract-plugin
module.exports = {"author":"contentMessage_author__QKEYT","message_wrapper":"contentMessage_message_wrapper__spV5W","hide":"contentMessage_hide__4f_8j"};